import { CASE_RISKS, CASE_STATUSES, CASE_STATUS_LABEL, RISK_LABEL } from '../../types/domain';
import type { CaseRisk, CaseStatus } from '../../types/domain';
import { Badge, type BadgeTone } from '../../components/primitives';

const RISK_TONE: Record<CaseRisk, BadgeTone> = {
  LOW: 'green',
  MEDIUM: 'amber',
  HIGH: 'red',
  CRITICAL: 'red',
};

const STATUS_TONE: Record<CaseStatus, BadgeTone> = {
  OPEN: 'red',
  IN_PROGRESS: 'amber',
  CLOSED: 'green',
  CANCELLED: 'neutral',
};

export function RiskBadge({ risk }: { risk: CaseRisk }): JSX.Element {
  return (
    <Badge tone={RISK_TONE[risk]} dot>
      {RISK_LABEL[risk]}
    </Badge>
  );
}

export function CaseStatusBadge({ status }: { status: CaseStatus }): JSX.Element {
  return <Badge tone={STATUS_TONE[status]}>{CASE_STATUS_LABEL[status]}</Badge>;
}

export function RiskOptions(): JSX.Element {
  return (
    <>
      {CASE_RISKS.map((risk) => (
        <option key={risk} value={risk}>
          {RISK_LABEL[risk]}
        </option>
      ))}
    </>
  );
}

export function StatusOptions(): JSX.Element {
  return (
    <>
      {CASE_STATUSES.map((status) => (
        <option key={status} value={status}>
          {CASE_STATUS_LABEL[status]}
        </option>
      ))}
    </>
  );
}

/** Opciones de empresa y área: llegan del catálogo del backend, nunca embebidas. */
export function CatalogOptions({
  options,
  placeholder,
}: {
  options: Array<{ id: string; label: string }> | undefined;
  placeholder: string;
}): JSX.Element {
  return (
    <>
      <option value="">{placeholder}</option>
      {(options ?? []).map((option) => (
        <option key={option.id} value={option.id}>
          {option.label}
        </option>
      ))}
    </>
  );
}
